// 云游机库
const pool = [
  {
    path: '/', // 登录
    component: () => import(/* webpackChunkName: "login" */ '@/views/login'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/pool/poollist/:mid', // 机房列表
    component: () => import(/* webpackChunkName: "poollist" */ '@/views/pool/poolList'),
    meta: {
      title: '游机机房',
    },
  },
  {
    path: '/pool/pooldetail/:mid/:pid', // 机房详情
    component: () => import(/* webpackChunkName: "pooldetail" */ '@/views/pool/poolDetail'),
    meta: {
      title: '机房信息',
    },
  },
  {
    path: '/pool/poolline/:mid/:pid', // 队列管理
    component: () => import(/* webpackChunkName: "poolline" */ '@/views/pool/poolLine'),
    meta: {
      title: '队列管理',
    },
  },
  {
    path: '/pool/poolcomputer/:mid/:pid', // 宿主机器
    component: () => import(/* webpackChunkName: "poolcomputer" */ '@/views/pool/poolComputer'),
    meta: {
      title: '宿主机器',
    },
  },
  {
    path: '/pool/taglist/:mid', // 队列标签
    component: () => import(/* webpackChunkName: "taglist" */ '@/views/pool/tagList'),
    meta: {
      title: '队列标签',
    },
  },
  {
    path: '/pool/pooledit/:mid', // 队列标签
    component: () => import(/* webpackChunkName: "pooledit" */ '@/views/pool/poolEdit'),
    meta: {
      title: 'pool上下架',
    },
  },
];

export default pool;
